import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginationApi } from '../../domain/pagination-api';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
})
export class PaginationComponent<T> {
  @Input() pagination!: PaginationApi<T>;
  @Input() perPageOptions: number[] = [1, 10, 20, 50, 100];

  @Output() pageChange = new EventEmitter<number>();
  @Output() perPageChange = new EventEmitter<number>();

  constructor() {
    console.log(this.pagination);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.pagination.totalPages) {
      this.pageChange.emit(page);
    }
  }

  onPerPageChange(value: string) {
    const perPage = parseInt(value, 10);
    this.perPageChange.emit(perPage);
  }

  /**
   * Gera as páginas a serem mostradas com reticências se necessário
   */
  pagesToShow(): (number | string)[] {
    const total = this.pagination.totalPages;
    const current = this.pagination.page;
    const delta = 2;
    const range: (number | string)[] = [];

    if (total <= 7) {
      for (let i = 1; i <= total; i++) range.push(i);
    } else {
      const left = Math.max(2, current - delta);
      const right = Math.min(total - 1, current + delta);

      range.push(1);

      if (left > 2) range.push('...');
      for (let i = left; i <= right; i++) range.push(i);
      if (right < total - 1) range.push('...');

      range.push(total);
    }

    return range;
  }

  onFirst() {
    this.pagination.page = 1;
    this.pageChange.emit(this.pagination.page);
  }

  onLast() {
    this.pagination.page = this.pagination.totalPages;
    this.pageChange.emit(this.pagination.page);
  }

  get isFirstPage() {
    return this.pagination.page === 1;
  }

  get isLastPage() {
    return this.pagination.page === this.pagination.totalPages;
  }
}
